module.exports = __webpack_public_path__ + "static/media/clock.bad4402a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/clock.svg
// module id = 106
// module chunks = 0